import { Button, Form, Row, Space, Table, Typography } from "antd";
import React, { useEffect, useRef, useState } from "react";
import Icon from "assets/icons";
import { ExcelSVG } from "assets";
import {
  ButtonExcel,
  ExpandSearch,
  InputFields,
  Notification,
} from "components/common";
import { columnsTable, dataField } from "./ReportOPD.config";
import dayjs from "dayjs";
import { FORMAT_TIME } from "types/enums";
import { receiveService } from "api";
import { exportFile } from "helper/common";
import e from "cors";

const ReportOPD = () => {
  const expandRef = useRef<any>();

  const [data, setData] = useState([]);
  const [form] = Form.useForm();
  // const [totalPage, setTotalPage] = useState();
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({
    start: dayjs(),
    end: dayjs(),
    page: 1,
    limit: 10,
  });
  const handleOnFinish = () => {};

  const formatParams = () => {
    const newData = {
      ...params,
      end: dayjs(params.end).format(FORMAT_TIME.dayFull),
      start: dayjs(params.start).format(FORMAT_TIME.dayFull),
    };

    return newData;
  };

  const getList = async () => {
    setLoading(true);
    try {
      const res = await receiveService.getLitOPD(formatParams());
      setData(res);
      setLoading(false);
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi lấy danh sách báo cáo OPD");
    }
  };

  useEffect(() => {
    getList();
  }, [params]);

  const handlePaginationChange = (page, pageSize) => {
    setParams({
      ...params,
      page: page,
      limit: pageSize,
    });
  };

  const getReportFile = async () => {
    const param = formatParams();

    if (param?.start != null || param.end !== null) {
      exportFile(
        "/qlkhambenh/phieu-kham/export-bao-cao-opd",
        formatParams(),
        `Báo cáo OPD`
      );
    } else {
      Notification("error", "");
    }
  };

  const onClickSearchButton = () => {
    const searchFields = expandRef.current?.getData();

    setParams({
      ...params,
      ...searchFields,
      page: 1,
    });
  };

  return (
    <div>
      <div className="container">
        <Form form={form} onFinish={handleOnFinish}>
          <Space direction="vertical" style={{ width: "100%" }}>
            <ExpandSearch
              ref={expandRef}
              onClickSearch={onClickSearchButton}
              fields={dataField}
              initialValues={params}
              isSearch={false}
              isExportExcel={true}
              isResetField={false}
              isSearchExpend={false}
              isShowDetail={true}
              handleExportExcel={getReportFile}
            ></ExpandSearch>
          </Space>
        </Form>
      </div>
      <div className="container">
        <Table
          loading={loading}
          bordered
          pagination={{
            position: ["bottomRight"],
            showSizeChanger: true,
            // total: totalPage,
            onChange: handlePaginationChange,
            current: params.page,
          }}
          dataSource={data}
          columns={columnsTable}
          scroll={{ x: "100%" }}
          summary={(data) => {
            const columnSums = {};

            // Initialize sums for each column
            columnsTable.forEach((column) => {
              if (column.children) {
                column.children.forEach((child) => {
                  columnSums[child.dataIndex] = 0;
                });
              } else {
                columnSums[column.dataIndex] = 0;
              }
            });

            // Calculate sums
            data.forEach((rowData) => {
              columnsTable.forEach((column) => {
                if (column.children) {
                  column.children.forEach((child) => {
                    columnSums[child.dataIndex] += rowData[child.dataIndex];
                  });
                } else {
                  columnSums[column.dataIndex] += rowData[column.dataIndex];
                }
              });
            });

            return (
              <Table.Summary.Row>
                {columnsTable.map((column, columnIndex) => {
                  if (column.children) {
                    return column.children.map((child, childIndex) => (
                      <Table.Summary.Cell
                        key={columnIndex + childIndex}
                        index={columnIndex + childIndex}
                        align="right"
                      >
                        {columnSums[child.dataIndex]}
                      </Table.Summary.Cell>
                    ));
                  }

                  if (column.dataIndex === "ngay") {
                    return (
                      <Table.Summary.Cell
                        key={columnIndex}
                        index={columnIndex}
                        colSpan={1}
                        align="center"
                      >
                        <Typography.Text strong>Tổng</Typography.Text>
                      </Table.Summary.Cell>
                    );
                  }

                  return (
                    <Table.Summary.Cell
                      align="right"
                      key={columnIndex}
                      index={columnIndex}
                    >
                      {columnSums[column.dataIndex]}
                    </Table.Summary.Cell>
                  );
                })}
              </Table.Summary.Row>
            );
          }}
        />
      </div>
    </div>
  );
};

export default ReportOPD;
